import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import { converterData } from "utils/convert";

export const formatarDataColeta = (coleta: IndicadorColeta| null) => {
    if (coleta == null || coleta.dataColeta == null) return "";
    if (coleta.indicador?.periodicidadeColeta?.tipoPeriodo == "MES") {
        return new Date(coleta.dataColeta).toLocaleDateString("pt-BR", { year: "numeric", month: "2-digit" });
    } else if (coleta.indicador?.periodicidadeColeta?.tipoPeriodo == "ANO") {
        return new Date(coleta.dataColeta).getFullYear().toString();
    } else {
        return converterData(coleta.dataColeta)
    }
}

export const isMetaAtingida = (valor: number, meta: number, tipoMeta: string|null) => {
    if(!meta || !tipoMeta) return true;
    if(!valor) return false;
    if(tipoMeta === "GTE") return valor >= meta;
    if(tipoMeta === "GT") return valor > meta;
    if(tipoMeta === "E") return valor === meta;
    if(tipoMeta === "LT") return valor < meta;
    if(tipoMeta === "LTE") return valor <= meta;
    return false;
}